const API_CONSTANT = {
  URL: {
    MOCK: "mock",
    CLIENT: "client",
    WEBSITE: "website",
    BASE_API: "base",
    MIDDLEWARE_V2: "middleware_v2",
    PG: "pg",
  },
  PATH: {
    BASE_API: "base_api",
    CLIENT: {
      REGISTER: "save",
      TECH_TEAM: "send-email",
    },
    LOGIN: {
      INITIATE: "session/initiate",
      VALIDATE: "session/verify-token",
    },
    USER: {
      DETAILS: "user/profile",
      UPDATE: "user/update",
    },
    APPLICATION: {
      LIST: "application/all-applications",
      CREATE: "application/create",
      DETAILS: "application/application-details",
      UPDATE: "application/update",
    },
    ANALYTICS: {
      DETAILS: "user/analytics/details",
      GRAPH: "user/analytics/graph",
    },
    ORGANISATION: {
      GET_TEAM_DETAILS: "user/user-details",
      UPDATE: "user/update-organization",
      ADD_USER: "user/add-user",
      REMOVE_USER: "user/remove-user",
    },
  },
};

export default API_CONSTANT;
